import ApplicationRequirementsPage from '@/pages/ApplicationRequirementsPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_layout/application-requirements')({
  component: ApplicationRequirementsPage,
});
